function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useEnvironment } from '../contexts';
import { ContainedButton, MainContainer, OutlinedButton, PaperBox } from '../.';
export var AuthConfirm = function AuthConfirm() {
    var environment = useEnvironment().environment;
    var originHref = new URL(window.location.href);
    var originParams = originHref.searchParams.get('origin');
    var state = originHref.searchParams.get('state');
    var redirectUri = originHref.searchParams.get('redirectUri');
    var _useState = _sliced_to_array(useState(false), 2), isAuthorizing = _useState[0], setIsAuthorizing = _useState[1];
    var cancelClicked = function cancelClicked() {
        window.location.href = environment.dashboardUrl;
    };
    var authorizeClicked = function authorizeClicked() {
        var loginUrl = new URL('/api/login', environment.apiUrl);
        loginUrl.searchParams.set('origin', originParams !== null && originParams !== void 0 ? originParams : '');
        loginUrl.searchParams.set('state', state !== null && state !== void 0 ? state : '');
        var redirectUriUrl = new URL('/api/authorize', environment.apiUrl);
        loginUrl.searchParams.set('redirect_uri', redirectUri !== null && redirectUri !== void 0 ? redirectUri : redirectUriUrl.toString());
        setIsAuthorizing(true);
        window.location.href = loginUrl.toString();
    };
    return /*#__PURE__*/ _jsx(MainContainer, {
        children: /*#__PURE__*/ _jsx(PaperBox, {
            footer: /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between w-full",
                children: [
                    /*#__PURE__*/ _jsx(OutlinedButton, {
                        label: "Cancel",
                        onClick: cancelClicked
                    }),
                    /*#__PURE__*/ _jsx(ContainedButton, {
                        disabled: isAuthorizing,
                        onClick: authorizeClicked,
                        label: isAuthorizing ? 'Authorizing...' : 'Authorize'
                    })
                ]
            }),
            children: /*#__PURE__*/ _jsx("div", {
                className: "user-details",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col items-center text-center mt-4 mb-4",
                    children: [
                        /*#__PURE__*/ _jsx("h4", {
                            className: "m-0 mb-2 text-[32px] font-semibold text-white",
                            children: "Authorize Zephyr CLI"
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "font-normal text-sm text-[var(--color-secondary)]",
                            children: [
                                "You are about to authorize the Zephyr CLI with your account.",
                                ' ',
                                /*#__PURE__*/ _jsx("br", {}),
                                " Please confirm this is what you want to do."
                            ]
                        })
                    ]
                })
            })
        })
    });
};
